import { render, staticRenderFns } from "./Blocare_masini_dialog.vue?vue&type=template&id=645e1043"
import script from "./Blocare_masini_dialog.vue?vue&type=script&lang=js"
export * from "./Blocare_masini_dialog.vue?vue&type=script&lang=js"
import style0 from "./Blocare_masini_dialog.vue?vue&type=style&index=0&id=645e1043&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports